import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'
import { $app } from '../../../app.service'
import { setProject, setStatuses } from '../../store/stage/stage.actions'
import { getProject } from '../../store/stage/stage.selectors'
import { AppState } from '../../store/storage'

@Injectable({ providedIn: 'root' })
export class AppCanOpenEditGuard {
   constructor(
      private _router: Router,
      private _state: Store<AppState>
   ) {}
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const projectId = route.paramMap.get('projectId')
      if (projectId) {
         $app.setProjectId(Number(projectId))
         this._state.dispatch(setProject({ projectId: Number(projectId) }))
         this._state.dispatch(setStatuses())
      }

      // wait for the project to be loaded and check permissions, if not allowed redirect to dashboard
      return this._state.select(getProject).pipe(
         filter((project) => !!project && project.id == Number(projectId)), // wait until the project is loaded and matches the requested projectId
         switchMap((project) => {
            if (project?.permission?.type != 'WRITE') {
               // Return a UrlTree for the redirect
               return of(this._router.createUrlTree([`${projectId}/dashboard`]))
            }
            return of(project?.permission?.type == 'WRITE')
         })
      )
   }
}
